export default [
  {
    label:
      'Hi! We haven’t received your latest aligner check-in and photos. Please upload them soon so we can review your progress and provide feedback. Thanks!',
    value: 'Reminder to those who haven’t sent an Aligner check in',
  },
  {
    label:
      'Hi! It looks like you missed changing your aligner. Please switch to the next one as soon as possible and let us know if you need any help.',
    value: 'Who have missed changing their aligner',
  },
  {
    label:
      'Hi. Just a friendly reminder about your upcoming aligner change. Please remember to fill out the Aligner check-in form and upload your photos.',
    value: 'Who have an Upcoming Aligner change',
  },
  {
    label:
      'Hello. I noticed that your aligners aren’t being worn for the full recommended hours. Consistent wear is crucial for your treatment. If you need any help or have issues, just let me know.',
    value: 'Friendly reminder for poor compliant patient',
  },
  {
    label:
      'Hi! It looks like your aligners aren’t being worn as suggested. Following the recommended hours is key for your progress. If you need any help, feel free to reach out.',
    value: 'Supportive reminder for poor compliant patient',
  },
  {
    label:
      'Hello! I’m impressed with your consistent wear of the aligners. You’re doing fantastic, and it’s making a difference. Keep it up!',
    value: 'Kudos to those wearing their aligners diligently!',
  },
]
